export const STOCK_WARNING_PERCENTAGE = 0.5;
export const LOCAL_STORAGE_CART_KEY_PREFIX = 'jbt-iops-cart';
export const UNIVERSAL_PRODUCTS_KEY = 'Universal Products';
